module.exports = __webpack_public_path__ + "static/media/fintechpower.3c9715ec.jpeg";